import React, { useState, useEffect, useRef, useCallback } from 'react';

function beep(freq = 880, duration = 120, vol = 0.15) {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.frequency.value = freq; osc.type = 'sine';
    gain.gain.setValueAtTime(vol, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration / 1000);
    osc.start(ctx.currentTime); osc.stop(ctx.currentTime + duration / 1000);
  } catch (e) {}
}

function vibrar(p) { if (navigator.vibrate) navigator.vibrate(p); }

export default function Cronometro3030({ series, execucaoSeg, descansaSeg, onConcluirSeries, lang }) {
  const totalSeries = parseInt(series) || 4;
  const execSeg = parseInt(execucaoSeg) || 30;
  const descSeg = parseInt(descansaSeg) || 30;

  const [fase, setFase] = useState('pronto');
  const [setAtual, setSetAtual] = useState(1);
  const [segundos, setSegundos] = useState(execSeg);
  const intervalRef = useRef(null);
  const pt = lang === 'pt';

  const limpar = () => { if (intervalRef.current) clearInterval(intervalRef.current); };

  useEffect(() => {
    if (fase === 'execucao' || fase === 'descanso') {
      intervalRef.current = setInterval(() => {
        setSegundos(s => {
          if (s <= 1) {
            clearInterval(intervalRef.current);
            if (fase === 'execucao') {
              if (setAtual >= totalSeries) {
                beep(440, 200, 0.2); beep(550, 200, 0.2);
                vibrar([200, 100, 200, 100, 400]);
                setFase('concluido');
                if (onConcluirSeries) onConcluirSeries();
              } else {
                beep(440, 150, 0.15); vibrar([200, 100, 100]);
                setFase('descanso'); setSegundos(descSeg);
              }
            } else {
              beep(660, 100, 0.12); beep(880, 120, 0.15); vibrar([100, 50, 100]);
              setSetAtual(s2 => s2 + 1); setFase('execucao'); setSegundos(execSeg);
            }
            return 0;
          }
          if (s === 4) beep(330, 80, 0.08);
          return s - 1;
        });
      }, 1000);
    }
    return limpar;
  }, [fase, setAtual, totalSeries, execSeg, descSeg, onConcluirSeries]);

  function iniciar() {
    setFase('execucao'); setSetAtual(1); setSegundos(execSeg);
    beep(880, 120, 0.15); vibrar([100]);
  }
  function pausar() { limpar(); setFase('pronto'); }
  function reiniciar() { limpar(); setFase('pronto'); setSetAtual(1); setSegundos(execSeg); }
  function avancar() {
    if (fase === 'execucao') {
      if (setAtual >= totalSeries) {
        setFase('concluido'); if (onConcluirSeries) onConcluirSeries();
      } else {
        setFase('descanso'); setSegundos(descSeg);
      }
    } else if (fase === 'descanso') {
      setSetAtual(s => s + 1); setFase('execucao'); setSegundos(execSeg);
    }
  }

  const cor = fase === 'execucao' ? '#2E7D32' : fase === 'descanso' ? '#18659E' : '#5B402E';
  const faseLabel = {
    pronto: pt ? 'Pronto' : 'Ready',
    execucao: pt ? 'EXECUTE' : 'GO',
    descanso: pt ? 'Descanse' : 'Rest',
    concluido: pt ? 'Concluído!' : 'Done!',
  }[fase];

  // Barra de progresso linear (substitui o SVG circular)
  const pct = fase === 'execucao'
    ? ((execSeg - segundos) / execSeg) * 100
    : fase === 'descanso'
    ? ((descSeg - segundos) / descSeg) * 100
    : fase === 'concluido' ? 100 : 0;

  return (
    <div style={{
      padding: '12px 14px',
      borderRadius: 20,
      border: `1.5px solid ${fase === 'execucao' ? 'rgba(46,125,50,0.3)' : fase === 'descanso' ? 'rgba(24,101,174,0.3)' : 'rgba(137,91,64,0.2)'}`,
      background: fase === 'execucao' ? 'rgba(46,125,50,0.04)' : fase === 'descanso' ? 'rgba(24,101,174,0.04)' : 'rgba(137,91,64,0.04)',
      marginTop: 10,
      transition: 'all 0.3s',
    }}>
      {/* Linha 1: bolinhas + timer + label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
        {/* Bolinhas de série */}
        <div style={{ display: 'flex', gap: 5 }}>
          {Array.from({ length: totalSeries }).map((_, i) => {
            const feito = fase === 'concluido' || i < setAtual - 1 || (i === setAtual - 1 && fase === 'descanso');
            const atual = i === setAtual - 1 && (fase === 'execucao' || fase === 'descanso');
            return (
              <div key={i} style={{
                width: 22, height: 22, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 10, fontWeight: 700,
                background: feito ? cor : 'transparent',
                border: `1.5px solid ${feito ? cor : atual ? cor : 'rgba(37,28,25,0.15)'}`,
                color: feito ? '#fff' : atual ? cor : '#8C7F70',
                transition: 'all 0.3s',
              }}>
                {feito ? '✓' : i + 1}
              </div>
            );
          })}
        </div>

        {/* Timer numérico compacto */}
        <div style={{ flex: 1, display: 'flex', alignItems: 'baseline', gap: 4 }}>
          {(fase === 'execucao' || fase === 'descanso') ? (
            <>
              <span style={{ fontFamily: "'Inter',sans-serif", fontSize: 28, fontWeight: 700, color: cor, lineHeight: 1 }}>{segundos}</span>
              <span style={{ fontSize: 11, color: cor, opacity: 0.7, textTransform: 'uppercase', letterSpacing: '0.04em' }}>seg</span>
            </>
          ) : (
            <span style={{ fontSize: 13, fontWeight: 700, color: cor }}>{faseLabel}</span>
          )}
        </div>

        {/* Label de fase */}
        {(fase === 'execucao' || fase === 'descanso') && (
          <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: cor }}>
            {faseLabel}
          </span>
        )}
      </div>

      {/* Barra de progresso */}
      <div style={{ height: 3, background: 'rgba(37,28,25,0.08)', borderRadius: 14, marginBottom: 10, overflow: 'hidden' }}>
        <div style={{
          height: '100%', width: `${pct}%`, background: cor, borderRadius: 14,
          transition: fase !== 'pronto' ? 'width 0.9s linear' : 'none',
        }} />
      </div>

      {/* Botões */}
      <div style={{ display: 'flex', gap: 6 }}>
        {fase === 'pronto' && (
          <button onClick={iniciar} style={{ flex: 1, padding: '9px', background: '#251C19', color: '#FAF7F2', border: 'none', borderRadius: 14, fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer', fontFamily: "'Inter',sans-serif" }}>
            {pt ? '▶ Iniciar' : '▶ Start'}
          </button>
        )}
        {(fase === 'execucao' || fase === 'descanso') && (
          <>
            <button onClick={pausar} style={{ padding: '9px 12px', background: 'transparent', border: '1.5px solid rgba(37,28,25,0.15)', color: '#8C7F70', borderRadius: 14, fontSize: 11, cursor: 'pointer', fontFamily: "'Inter',sans-serif" }}>
              ⏸
            </button>
            <button onClick={avancar} style={{ flex: 1, padding: '9px', background: cor, color: '#fff', border: 'none', borderRadius: 14, fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em', cursor: 'pointer', fontFamily: "'Inter',sans-serif" }}>
              {fase === 'execucao' ? (pt ? 'Finalizar set →' : 'End set →') : (pt ? 'Próximo →' : 'Next →')}
            </button>
          </>
        )}
        {fase === 'concluido' && (
          <button onClick={reiniciar} style={{ flex: 1, padding: '9px', background: 'transparent', border: `1.5px solid ${cor}`, color: cor, borderRadius: 14, fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: "'Inter',sans-serif" }}>
            {pt ? 'Repetir' : 'Repeat'}
          </button>
        )}
      </div>
    </div>
  );
}
